import EditIcon from "@mui/icons-material/Edit";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { type Dispatch, type SetStateAction, useState } from "react";
import AddDayOffDialog from "../../../components/AddDayOffDialog/AddDayOffDialog";
import { DoubleClickDeleteIcon } from "../../../components/UIToolkit/Clickable/DoubleClickDeleteIcon";
import { INK, NEUTRAL } from "../../../theme/tokens";
import type { DayOffWithNurseId } from "../../../utils/models";
import { useEditDayOff } from "../../Profile/v2/DaysOffAndPTO/useEditDayOff";

type Props = {
	dayOff: DayOffWithNurseId;
	onDeleteConfirmed: (dayOff: DayOffWithNurseId) => void;
	isDeleteLoading?: boolean;
	timeOffToEdit: DayOffWithNurseId | null;
	setTimeOffToEdit: Dispatch<SetStateAction<DayOffWithNurseId | null>>;
};

export const ExistingLongPTOItem = ({ dayOff, onDeleteConfirmed, isDeleteLoading, setTimeOffToEdit, timeOffToEdit }: Props) => {
	const [isConfirmed, setIsConfirmed] = useState(false);
	const { handleEditSave } = useEditDayOff({
		nurseId: dayOff.nurseId,
		onSaved: () => setTimeOffToEdit(null),
	});

	const handleConfirm = () => {
		setIsConfirmed(true);
		onDeleteConfirmed(dayOff);
	};

	const isEditOpen = timeOffToEdit?.id === dayOff.id;
	return (
		<>
			<Tooltip title={dayOff.reasons[0]}>
				<Box
					sx={{
						display: "flex",
						justifyContent: "start",
						alignItems: "center",
						gap: 2,
						fontSize: "14px",
						lineHeight: "16px",
						color: INK.SECONDARY,

						":hover": {
							backgroundColor: NEUTRAL[100],
						},
					}}
				>
					<Typography
						sx={{
							fontSize: "inherit",
							lineHeight: "inherit",
							color: "inherit",
							whiteSpace: "nowrap",
						}}
					>
						{`(${dayOff.dateFrom.toFormat("MMM d")} - ${dayOff.dateTo.toFormat("MMM d")})`}
					</Typography>
					<IconButton size="small" onClick={() => setTimeOffToEdit(dayOff)}>
						<EditIcon
							fontSize="inherit"
							sx={{
								opacity: 0.2,
								transition: "opacity 0.3s ease",
								":hover": {
									opacity: 1,
								},
							}}
						/>
					</IconButton>
					<DoubleClickDeleteIcon isLoading={isDeleteLoading && isConfirmed} onDeleteConfirmed={handleConfirm} />
				</Box>
			</Tooltip>
			{isEditOpen && (
				<AddDayOffDialog open={isEditOpen} onClose={() => setTimeOffToEdit(null)} onSave={handleEditSave} nurseId={dayOff.nurseId} dayOff={dayOff} />
			)}
		</>
	);
};
